import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputGroup<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: number;
  /** Alias: index */
  index?: number;
  /** Alias: parentCode */
  parentId?: number;
  /** Alias: name */
  name?: string;

  __typename?: string;
}

const fields: FieldDefinitions<InputGroup> = {
  id: {
    alias: 'code',
  },
  index: {
    alias: 'index',
  },
  parentId: {
    alias: 'parentCode',
  },
  name: {
    alias: 'name',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputGroupEntityDefinition: EntitiyDefinition<InputGroup> = {
  local: {},
  remote: {
    queryName: '',
    fragmentName: 'InputGroup',
    withPaginationWrapper: false,
  },
  fieldDefinitions: fields,
};
